<template>
	<o-card
		class="orders-main-dashboard"
		:gradient="color">
		<o-icon
			class="orders-main-dashboard__icon"
			font-icon="icon-shopping-cart-1"/>
		<h3 class="orders-main-dashboard__title">
			Vos commandes
		</h3>
		<div
			v-if="setup.loaded"
			class="orders-main-dashboard__section">
			<div class="orders-main-dashboard__section-value">
				<strong>{{ setup.filledCount }}</strong>
				<p>{{ `${'Commande'.pluralize(setup.filledCount, false)} à finaliser` }}</p>
			</div>
			<o-button
				outline
				color="default"
				@click="$router.push({ name: 'Order', query: { filter: qsTo64({ status: [ORDER_STATUS.Filled] }) } })">
				Voir
			</o-button>
		</div>
		<div
			class="orders-main-dashboard__section">
			<div class="orders-main-dashboard__section-value">
				<strong>{{ setup.newCount }}</strong>
				<p>{{ `${'Nouvelle commande'.pluralize(setup.newCount, false)}` }}</p>
			</div>
			<o-button
				outline
				color="default"
				@click="$router.push({ name: 'Order', query: { filter: qsTo64({ filter: ORDER_DASHBOARD_FILTER.New }) } })">
				Voir
			</o-button>
		</div>
		<div
			class="orders-main-dashboard__section">
			<div class="orders-main-dashboard__section-value">
				<strong>{{ setup.urgentCount }}</strong>
				<p>{{ `${'Commande urgente'.pluralize(setup.urgentCount, false)}` }}</p>
			</div>
			<o-button
				outline
				color="default"
				@click="$router.push({
					name: 'Order',
					query: {
						filter: qsTo64({
							filter: ORDER_DASHBOARD_FILTER.Urgent,
							status: [ORDER_STATUS.Created, ORDER_STATUS.Filled],
						}),
					},
				})">
				Voir
			</o-button>
		</div>
		<template #actions>
			<o-button
				color="default"
				outline
				@click="$router.push({ name: 'OrderDashboard' })">
				Vue d'ensemble des commandes
			</o-button>
		</template>
		<o-loader
			:color="color"
			:visible="!setup.loaded"/>
	</o-card>
</template>

<script setup lang="ts">
import DashboardOrdersMainCardSetupService from '@/setup/dashboard/DashboardOrdersMainCardSetupService';
import { ORDER_DASHBOARD_FILTER } from '@/typings/enums/ORDER_DASHBOARD_FILTER';
import { ORDER_STATUS } from '@/typings/enums/ORDER_STATUS';
import { qsTo64 } from '@/utils/tools';
const props = defineProps(DashboardOrdersMainCardSetupService.props);
const setup = new DashboardOrdersMainCardSetupService(props);
</script>

<style scoped lang="less">
.orders-main-dashboard {
  height: 100%;
  position: relative;

  &__icon {
    font-size: 7.5rem;
    opacity: 0.15;
    position: absolute;
    top: 1rem;
    right: 1rem;
  }

  &__title {
    margin: 0.5rem 0 1rem;
    padding: 0.25rem;
    color: white;
  }

	&__section {
		display: flex;
		align-items: center;
		justify-content: space-between;
		margin-top: 0.5rem;

		&-value {
			display: flex;
			align-items: center;
		}

		strong {
			color: white;
			transform: translateY(-0.13rem);
			margin-right: 0.5rem;
			font-size: 3rem;
			line-height: 1;
			font-weight: bold;
			text-shadow: 0 0.125rem 0.2rem rgb(0 0 0 / 20%);
		}

		p {
			margin: unset;
			text-transform: uppercase;
			font-weight: 700;
		}
	}

}
</style>
